/* SPINE — LIFE RPG PRODUCT PAGE
   Phase 3 — modal flow with quest-completion tick

   The BEGIN button briefly animates the active quest as
   "completed" (~600ms), then opens the deliverables modal.
   Modal entrance polish (scale + fade) is CSS-driven via
   the [aria-hidden] attribute on the modal root.

   Modal supports backdrop close, X close, Escape close,
   focus trap, body scroll lock. Close paths bifurcate:
   BACK TO BUY ↑ scrolls to the buy box (opt-in); X and
   backdrop close without scrolling (opt-out).
*/

(function () {
  'use strict';

  const root = document.querySelector('[data-life-viewer]');
  if (!root) return;

  const beginButton    = document.querySelector('[data-life-begin]');
  const modal          = document.querySelector('[data-life-modal]');
  const modalCloseBtns = modal ? modal.querySelectorAll('[data-life-modal-close]') : [];

  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const scrollBehavior = prefersReducedMotion ? 'auto' : 'smooth';

  /* Tick timing — long enough for the strike + flare to read */
  const tickDuration = prefersReducedMotion ? 0 : 600;

  let lastFocusedElement = null;
  let ticking = false;

  /* ---- Helpers ---- */

  function getFocusableElements(container) {
    return container.querySelectorAll(
      'button:not([disabled]), [href], input:not([disabled]), ' +
      'select:not([disabled]), textarea:not([disabled]), ' +
      '[tabindex]:not([tabindex="-1"])'
    );
  }

  function clearTickState() {
    const completing = document.querySelectorAll('.is-completing');
    completing.forEach((el) => el.classList.remove('is-completing'));
  }

  /* ---- Quest tick ---- */

  function performTick(onComplete) {
    const activeQuest = document.querySelector('.life-quest-list__item.is-active');

    if (!activeQuest || prefersReducedMotion) {
      if (typeof onComplete === 'function') onComplete();
      return;
    }

    ticking = true;
    activeQuest.classList.add('is-completing');

    setTimeout(() => {
      ticking = false;
      if (typeof onComplete === 'function') onComplete();
    }, tickDuration);
  }

  /* ---- Modal ---- */

  function openModal() {
    if (!modal) return;
    lastFocusedElement = document.activeElement;
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('life-modal-open');

    const focusables = getFocusableElements(modal);
    if (focusables.length) {
      focusables[0].focus();
    }
  }

  function closeModal(scrollToBuy) {
    if (!modal) return;
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('life-modal-open');

    /* Reset the tick on close — the quest hasn't actually been completed,
       it was just a moment of demonstration */
    clearTickState();

    if (lastFocusedElement && typeof lastFocusedElement.focus === 'function') {
      lastFocusedElement.focus();
    }
    lastFocusedElement = null;

    if (scrollToBuy) {
      const buyBox = document.querySelector('.life-fold');
      if (buyBox) {
        buyBox.scrollIntoView({ behavior: scrollBehavior, block: 'start' });
      }
    }
  }

  /* ---- Event wiring ---- */

  if (beginButton) {
    beginButton.addEventListener('click', (e) => {
      e.preventDefault();
      if (ticking) return;
      if (modal && modal.getAttribute('aria-hidden') === 'false') return;
      performTick(openModal);
    });
  }

  modalCloseBtns.forEach((btn) => {
    btn.addEventListener('click', () => {
      const isCta = btn.classList.contains('life-modal__cta');
      closeModal(isCta);
    });
  });

  /* ---- Keyboard ---- */

  document.addEventListener('keydown', (e) => {
    if (modal && modal.getAttribute('aria-hidden') === 'false' && e.key === 'Tab') {
      const focusables = getFocusableElements(modal);
      if (!focusables.length) return;

      const first = focusables[0];
      const last  = focusables[focusables.length - 1];

      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
      return;
    }

    if (e.key === 'Escape') {
      if (modal && modal.getAttribute('aria-hidden') === 'false') {
        closeModal(false);
      }
    }
  });

})();